import React from "react";
import "../style/Footer.css";
import logo from "../logo.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <div className="Footer">
        <ul className="links">
          <li>
            <a
              href="https://brainster.co/about"
              target="_blank"
              rel="noopener noreferrer"
            >
              About us
            </a>
          </li>
          <li>
            <a
              href="https://brainster.co/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/pg/brainster.co/photos/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gallery
            </a>
          </li>
        </ul>
        <Link to={`/`}>
          <img className="imgFooter" src={logo} alt="brainster_logo" />
        </Link>
        <div className="social">
          <a
            href="https://www.linkedin.com/school/brainster-co/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-linkedin fa-lg" aria-hidden="true"></i>
          </a>
          <a
            href="https://twitter.com/BrainsterCo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-twitter fa-lg" aria-hidden="true"></i>
          </a>
          <a
            href="https://www.facebook.com/brainster.co"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-facebook fa-lg" aria-hidden="true"></i>
          </a>
        </div>
      </div>

      <div className="FooterMobile">
        <div className="social">
          <a
            href="https://www.linkedin.com/school/brainster-co/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-linkedin fa-lg" aria-hidden="true"></i>
          </a>
          <a
            href="https://twitter.com/BrainsterCo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-twitter fa-lg" aria-hidden="true"></i>
          </a>
          <a
            href="https://www.facebook.com/brainster.co"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-facebook fa-lg" aria-hidden="true"></i>
          </a>
        </div>
        <ul className="links">
          <li>
            <a
              href="https://brainster.co/about"
              target="_blank"
              rel="noopener noreferrer"
            >
              About us
            </a>
          </li>
          <li>
            <a
              href="https://brainster.co/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/pg/brainster.co/photos/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gallery
            </a>
          </li>
        </ul>
        <Link to={`/`}>
          <img className="imgFooter" src={logo} alt="brainster_logo" />
        </Link>
      </div>
    </div>
  );
};

export default Footer;
